import { useProviderSearchContext } from "context/ProviderSearchContext";
import { ProviderSearchPage } from "core/types";
import { usePageMetaData } from "dsl/hooks";

export const useProviderSearchPageData = (page: ProviderSearchPage) => {
  const {
    config: { pageMetaData },
  } = useProviderSearchContext();

  usePageMetaData(pageMetaData(page));
};
